module.exports = __webpack_public_path__ + "static/ND_Patientsite_homepage_slider2-mobile-cd45c81dee2c11efd85e346717b185e4.png";